import { _getAxios, _getAxiosWithoutInterceptor, _getAxiosWithoutInterceptorNoCache, serviceMain, setHeader } from './serviceMain';

export function getUserPoints(groupCode: string, storeCode: string, card: string, catalogId?: string) {

    const queryParams = new URLSearchParams({
        groupCode: groupCode,
        storeCode: storeCode,
        card: card,
        catalogId: catalogId ? catalogId : ''
      });

  const url = '/v3/customer/points';
    
  return _getAxios(url, "GET_POINTS_TIME" , "points", queryParams); //WithoutInterceptor
};
export function getUserPointsNoCache(groupCode: string, storeCode: string, card: string, catalogId?: string) {
  const queryParams = new URLSearchParams({
      groupCode: groupCode,
      storeCode: storeCode,
      card: card,
      catalogId: catalogId || '',
      t: Date.now().toString() // Parametro univoco se vuoi evitare qualsiasi cache di rete
  });

  const url = '/v3/customer/points';
  return _getAxiosWithoutInterceptorNoCache(url, queryParams);
}